export const GET_PRODUCTS = "/products"

export const GET_ALL_PRODUCTS = "/products/all"

export const DELETE_PRODUCT_BY_ID = "/products/:id"

export const RESTORE_PRODUCT_BY_ID = "/products/:id/restore"

export const POST_PRODUCT = "/products"

export const UPDATE_PRODUCT = "/products/:id"
